export enum AtsExportPreset {
    AtsReportCsv = "ats_report_csv",
    AtsReportXlsx = "ats_report_xlsx",
    AtsReportXlsxWithImages = "ats_report_xlsx_with_images",
}

export const DEFAULT_TEMPLATE_NAME = "Untitled Template";
